import React from 'react'
import { DialogContent } from '@mui/material'

/**
 * @typedef {object} StyledDialogContentProps
 * @property {React.ReactNode} children - El contenido que se renderizará dentro del DialogContent.
 * @property {object} [sx={}] - Objeto de estilos adicionales que se fusionarán con los estilos predeterminados del componente.
 */

/**
 * Un componente envolvente de DialogContent de Material-UI con estilos predeterminados personalizados.
 * 
 * Este componente aplica un padding superior reducido al contenido del diálogo para mejorar
 * la apariencia visual y el espaciado entre el título y el contenido. Los estilos adicionales
 * proporcionados a través de la prop `sx` se fusionan con los estilos predeterminados.
 * 
 * Se utiliza internamente en los componentes de diálogo como `AcceptationDialog` y
 * `ConfirmationDialog` para mantener una apariencia consistente en toda la aplicación.
 * 
 * @component
 * @example
 * const MyDialog = () => {
 *   return (
 *     <Dialog open={true}>
 *       <DialogTitle>Mi Diálogo</DialogTitle>
 *       <StyledDialogContent sx={{ minHeight: '200px' }}>
 *         <Typography>Este es el contenido del diálogo con estilos personalizados.</Typography>
 *       </StyledDialogContent>
 *       <DialogActions>
 *         <Button>Cerrar</Button>
 *       </DialogActions>
 *     </Dialog>
 *   );
 * };
 * 
 * @param {StyledDialogContentProps} props - Las props del componente StyledDialogContent.
 */
export const StyledDialogContent = ({ children, sx = {}, ...props }) => {
  return (
    <DialogContent
      sx={{
        paddingTop: '8px !important',
        ...sx,
      }}
      {...props}
    >
      {children}
    </DialogContent>
  )
}
